/**
 * CompanyArchivesLocation
 *
 * Location wrapper for the Company Archives/Events view.
 * Maps to the "Archives" tab in the original navigation.
 */

import React from 'react';
import { CampusLocation } from '../../types/spatial';
import LocationWrapper from '../spatial/LocationWrapper';
import { EnhancedEventLog } from '../tycoon/events/EnhancedEventLog';
import { useDynamicEvents } from '../../stores/eventStore';

export const CompanyArchivesLocation: React.FC = () => {
  const { data } = useDynamicEvents();

  // Combine all event sources into single array
  const events = [
    ...(data?.eventHistory || []),
    ...(data?.activeEvents || []),
    ...(data?.pendingReactiveEvents || [])
  ];

  return (
    <LocationWrapper
      location={CampusLocation.COMPANY_ARCHIVES}
      title="Company Archives"
    >
      <EnhancedEventLog events={events} />
    </LocationWrapper>
  );
};

export default CompanyArchivesLocation;
